export function other_field(parameters, fields = {}) {
  const [other] = parameters;
  return {
    other: other in fields ? fields[other] : other
  };
}
